import { render, staticRenderFns } from "./layout-auth.vue?vue&type=template&id=42a26a38"
import script from "./layout-auth.vue?vue&type=script&lang=js"
export * from "./layout-auth.vue?vue&type=script&lang=js"
import style0 from "./layout-auth.vue?vue&type=style&index=0&id=42a26a38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports